/* TDR Mix Composer - full-screen overlay state machine, 2026-04-24 */
(function () {
  'use strict';

  var root = document.getElementById('tdr-mix-composer');
  if (!root) return;

  var TOTAL = 60;
  var STEP = 10;
  var STORAGE_KEY = 'tdrMixDraft';

  // Bridge endpoint - subscriptions go via Mollie via this Next.js service.
  // Override per env by setting window.TDR_BRIDGE_URL before this script loads.
  var BRIDGE_URL = (window.TDR_BRIDGE_URL || 'https://tdr-subscriptions-bridge.vercel.app');

  // Cadence config: weeks → label only. Flat pricing across cadences (no discount).
  // Bas configures matching selling plans in admin (Elke 2/3/4/5/6 weken).
  // Shorter cadence ≠ cheaper. Customer chooses how often they want delivery.
  var CADENCE = {
    '2': { label: '2 weken' },
    '3': { label: '3 weken' },
    '4': { label: '4 weken · onze standaard' },
    '5': { label: '5 weken' },
    '6': { label: '6 weken' }
  };
  var DEFAULT_CADENCE = '4';

  // Elements
  var backdrop = root.querySelector('[data-tdr-mc-close].tdr-mc__backdrop');
  var closes = root.querySelectorAll('[data-tdr-mc-close]');
  var backBtn = root.querySelector('[data-tdr-mc-back]');
  var stepEls = root.querySelectorAll('[data-tdr-mc-step]');
  var pathBtns = root.querySelectorAll('[data-tdr-mc-select]');
  var picks = root.querySelectorAll('[data-tdr-mc-pick]');
  var progressFill = root.querySelector('[data-tdr-mc-fill]');
  var progressText = root.querySelector('[data-tdr-mc-progress-text]');
  var submitBtn = root.querySelector('[data-tdr-mc-submit]');
  var tpSubmitBtn = root.querySelector('[data-tdr-mc-tp-submit]');
  var warnEl = root.querySelector('[data-tdr-mc-warn]');
  var detailsForm = root.querySelector('[data-tdr-mc-details-form]');
  var detailsSubmitBtn = root.querySelector('[data-tdr-mc-details-submit]');
  var detailsWarnEl = root.querySelector('[data-tdr-mc-details-warn]');
  var detailsAmountEl = root.querySelector('[data-tdr-mc-details-amount]');
  var methodsGrid = root.querySelector('[data-tdr-mc-methods-grid]');
  var cadenceSelect = root.querySelector('[data-tdr-mc-cadence]');
  var cadenceHint = root.querySelector('[data-tdr-mc-cadence-hint]');
  var footerAmountEl = root.querySelector('[data-tdr-mc-footer-amount]');
  var footerUnitEl = root.querySelector('[data-tdr-mc-footer-unit]');
  var footerPriceEl = root.querySelector('[data-tdr-mc-footer-price]');
  var summaryMixEl = root.querySelector('[data-tdr-mc-summary-mix]');
  var summaryCadenceEl = root.querySelector('[data-tdr-mc-summary-cadence]');
  var summaryTotalEl = root.querySelector('[data-tdr-mc-summary-total]');
  var summaryEditBtn = root.querySelector('[data-tdr-mc-summary-edit]');

  // State
  var state = {
    open: false,
    step: 'path',
    path: null,
    picks: { focus: 0, drive: 0, unwind: 0 },
    cadence: DEFAULT_CADENCE,
    submitting: false
  };

  // Restore session draft
  try {
    var saved = sessionStorage.getItem(STORAGE_KEY);
    if (saved) {
      var parsed = JSON.parse(saved);
      if (parsed && parsed.picks) state.picks = Object.assign(state.picks, parsed.picks);
      if (parsed && parsed.path) state.path = parsed.path;
      if (parsed && parsed.cadence && CADENCE[parsed.cadence]) state.cadence = parsed.cadence;
    }
  } catch (e) { /* ignore */ }

  function saveDraft() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ path: state.path, picks: state.picks, cadence: state.cadence }));
    } catch (e) { /* ignore */ }
  }

  // Match plan name to weeks digit. "elke 2 weken", "every 2 weeks", "2-week", "2 wk".
  function planMatchesWeeks(planName, weeks) {
    var n = (planName || '').toLowerCase();
    var re = new RegExp('(^|\\D)' + weeks + '\\s*(weken|week|weeks|wk)');
    return re.test(n);
  }

  // Resolve plan object (with id + pct) for a pick and cadence.
  function resolvePlan(pick, cadenceWeeks) {
    var raw = pick.getAttribute('data-selling-plans');
    var plans = [];
    if (raw) { try { plans = JSON.parse(raw); } catch (e) { plans = []; } }
    if (!plans.length) {
      var fb = pick.getAttribute('data-selling-plan-id');
      return fb ? { id: Number(fb), pct: 0 } : null;
    }
    var match = plans.find(function (p) { return planMatchesWeeks(p.name, cadenceWeeks); });
    return match || plans[0];
  }
  function resolvePlanId(pick, cadenceWeeks) {
    var p = resolvePlan(pick, cadenceWeeks);
    return p ? Number(p.id) : null;
  }
  // Discount % for a cadence - read from the FIRST pick's matched plan.
  // Assumes Bas configures consistent discounts across rituals.
  function getCadenceDiscount(cadenceWeeks) {
    if (!picks || picks.length === 0) return 0;
    var p = resolvePlan(picks[0], cadenceWeeks);
    return p ? Number(p.pct || 0) : 0;
  }

  // Detect available cadences across ALL picks (intersection).
  // A cadence is offered only if every pick has a matching plan.
  function detectAvailableCadences() {
    if (!picks || picks.length === 0) return Object.keys(CADENCE);
    var perPick = [];
    Array.prototype.forEach.call(picks, function (pick) {
      var raw = pick.getAttribute('data-selling-plans');
      var plans = [];
      if (raw) { try { plans = JSON.parse(raw); } catch (e) {} }
      var found = {};
      plans.forEach(function (p) {
        var m = (p.name || '').toLowerCase().match(/(\d+)\s*(weken|week|weeks|wk)/);
        if (m) found[m[1]] = true;
      });
      perPick.push(found);
    });
    return Object.keys(CADENCE).filter(function (weeks) {
      return perPick.every(function (set) { return set[weeks]; });
    });
  }

  // Check if at least one product has any selling plan at all.
  function hasAnyPlans() {
    return Array.prototype.some.call(picks, function (pick) {
      var raw = pick.getAttribute('data-selling-plans');
      if (!raw) return !!pick.getAttribute('data-selling-plan-id');
      try { return JSON.parse(raw).length > 0; } catch (e) { return false; }
    });
  }

  // Apply the available-cadence set to the dropdown UI.
  // Logic tree:
  //   - cadences detected via name regex >= 2 → strict mode, hide options not in set
  //   - exactly 1 cadence detected → static label, no choice
  //   - 0 detected, but plans exist → permissive mode (show all, fall back to first plan on submit)
  //   - no plans at all → "niet beschikbaar"
  function applyAvailableCadences() {
    if (!cadenceSelect) return;
    var avail = detectAvailableCadences();
    var card = root.querySelector('[data-tdr-mc-cadence-card]');

    if (avail.length >= 2) {
      Array.prototype.forEach.call(cadenceSelect.options, function (opt) {
        var ok = avail.indexOf(opt.value) !== -1;
        opt.hidden = !ok;
        opt.disabled = !ok;
        if (ok) {
          var pct = getCadenceDiscount(opt.value);
          var base = (CADENCE[opt.value] && CADENCE[opt.value].label) || (opt.value + ' weken');
          opt.textContent = pct > 0 ? base + ' · -' + pct + '%' : base;
        }
      });
      if (avail.indexOf(state.cadence) === -1) {
        state.cadence = (avail.indexOf(DEFAULT_CADENCE) !== -1) ? DEFAULT_CADENCE : avail[0];
        cadenceSelect.value = state.cadence;
      }
      return;
    }

    if (avail.length === 1) {
      var only = avail[0];
      var label = (CADENCE[only] && CADENCE[only].label) || (only + ' weken');
      if (card) {
        card.innerHTML = ''
          + '<div class="tdr-mc__cadence-row">'
          + '  <div class="tdr-mc__cadence-text">'
          + '    <p class="tdr-mc__cadence-eyebrow">Leveringsritme</p>'
          + '    <p class="tdr-mc__cadence-headline">Elke ' + label + ' bij je thuis.</p>'
          + '  </div>'
          + '</div>'
          + '<p class="tdr-mc__cadence-hint">Een levering overslaan kan altijd, zonder gedoe.</p>';
      }
      state.cadence = only;
      return;
    }

    // 0 cadences detected via regex.
    if (hasAnyPlans()) {
      // Permissive mode: plans exist but names don't include "X weken".
      // Show all 5 options. Cart-side will use first available plan as fallback.
      // For accurate per-cadence delivery: admin should rename plans (e.g. "Elke 4 weken").
      return;
    }

    // No plans at all → not subscribable.
    if (card) {
      card.innerHTML = '<p class="tdr-mc__cadence-hint" data-tdr-mc-cadence-hint>Abonnement is tijdelijk niet beschikbaar. <a href="/pages/contact">Neem contact op</a> en we helpen je verder.</p>';
    }
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Abonnement niet beschikbaar';
    }
  }

  function totalCups() {
    return state.picks.focus + state.picks.drive + state.picks.unwind;
  }

  function showStep(name) {
    state.step = name;
    stepEls.forEach(function (el) {
      var match = el.getAttribute('data-tdr-mc-step') === name;
      if (match) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
    if (backBtn) {
      if (name === 'path') backBtn.setAttribute('hidden', '');
      else backBtn.removeAttribute('hidden');
    }
    // Focus management
    var firstFocusable = root.querySelector('[data-tdr-mc-step]:not([hidden]) button, [data-tdr-mc-step]:not([hidden]) a, [data-tdr-mc-step]:not([hidden]) input');
    if (firstFocusable) firstFocusable.focus({ preventScroll: true });
  }

  function open(path) {
    state.open = true;
    root.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    // Mark siblings inert for focus trap
    var children = document.body.children;
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (c !== root && c.tagName !== 'SCRIPT') {
        c.setAttribute('inert', '');
        c.setAttribute('aria-hidden', 'true');
      }
    }
    // Always open directly on the subscription builder.
    selectPath('abo');
  }

  function close() {
    state.open = false;
    root.setAttribute('hidden', '');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    var children = document.body.children;
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (c !== root) {
        c.removeAttribute('inert');
        c.removeAttribute('aria-hidden');
      }
    }
    // Strip ?mix=... from URL
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      if (url.searchParams.has('mix') || url.searchParams.has('composer')) {
        url.searchParams.delete('mix');
        url.searchParams.delete('composer');
        window.history.replaceState({}, '', url.toString());
      }
    }
  }

  // Subscription is the only path. Any value (including 'testpakket' from
  // legacy deep links) routes to the abo builder.
  function selectPath() {
    state.path = 'abo';
    saveDraft();
    showStep('abo');
    renderAbo();
  }

  function update(slug, delta) {
    if (!(slug in state.picks)) return;
    var t = totalCups();
    var next = Math.max(0, Math.min(TOTAL, state.picks[slug] + delta));
    if (t - state.picks[slug] + next > TOTAL) return;
    state.picks[slug] = next;
    saveDraft();
    renderAbo();
  }

  function renderAbo() {
    var t = totalCups();
    var remaining = TOTAL - t;
    var complete = t === TOTAL;
    var hasMissingPlan = false;
    var hasOOS = false;
    var missingNames = [];
    var oosNames = [];
    var priceSum = 0;

    picks.forEach(function (pick) {
      var slug = pick.getAttribute('data-tdr-mc-pick');
      var cups = state.picks[slug];
      var inStock = pick.getAttribute('data-in-stock') !== 'false';
      var priceCents = parseInt(pick.getAttribute('data-variant-price') || '0', 10);
      pick.setAttribute('data-active', cups > 0 ? 'true' : 'false');
      var cupsEl = pick.querySelector('[data-tdr-mc-cups]');
      if (cupsEl) cupsEl.textContent = cups;
      var dec = pick.querySelector('[data-tdr-mc-dec]');
      var inc = pick.querySelector('[data-tdr-mc-inc]');
      if (dec) dec.disabled = cups === 0;
      if (inc) inc.disabled = t >= TOTAL || !inStock;
      // Selling plan check
      if (cups > 0 && pick.getAttribute('data-has-selling-plan') === 'false') {
        hasMissingPlan = true;
        var nameEl = pick.querySelector('.tdr-mc__pick-name');
        if (nameEl) missingNames.push(nameEl.textContent.trim());
      }
      // In-stock check
      if (!inStock) {
        pick.setAttribute('data-oos', 'true');
        if (cups > 0) {
          hasOOS = true;
          var nmEl = pick.querySelector('.tdr-mc__pick-name');
          if (nmEl) oosNames.push(nmEl.textContent.trim());
        }
      } else {
        pick.removeAttribute('data-oos');
      }
      // Price accumulation (cups / STEP = kartons)
      priceSum += priceCents * (cups / STEP);
    });

    if (progressText) progressText.textContent = t;
    if (progressFill) progressFill.style.width = (t / TOTAL * 100) + '%';

    // Live footer total: variant prices × kartons, then apply selling-plan discount %.
    var cad = CADENCE[state.cadence] || CADENCE[DEFAULT_CADENCE];
    var discountPct = getCadenceDiscount(state.cadence);
    var basePrice = priceSum / 100;
    var displayPrice = basePrice * (1 - discountPct / 100);
    if (footerAmountEl) {
      // Show the WELKOMSPRIJS (first delivery, -30%) when the mix is complete.
      // Everyone using the composer is signing up fresh, so cycle 1 is what
      // they actually pay now. Anchor price stays visible underneath.
      var label = complete ? 'EUR 41,96' : 'EUR ' + displayPrice.toFixed(2).replace('.', ',');
      footerAmountEl.textContent = label;
    }
    if (footerPriceEl) {
      if (complete) footerPriceEl.removeAttribute('data-incomplete');
      else footerPriceEl.setAttribute('data-incomplete', 'true');
    }
    if (footerUnitEl) {
      footerUnitEl.innerHTML = complete
        ? 'eerste levering &middot; <strong>welkomstkorting -30%</strong> &middot; daarna oplopend, normaal EUR 59,94'
        : 'per levering elke ' + cad.label + ' · altijd opzegbaar';
    }
    if (cadenceHint) {
      if (discountPct > 0) {
        cadenceHint.innerHTML = '<strong>Bespaar ' + discountPct + '%</strong> bij elke ' + cad.label + ' &middot; een levering overslaan kan altijd.';
      } else {
        cadenceHint.textContent = 'Een levering overslaan kan altijd, zonder gedoe.';
      }
    }

    if (warnEl) {
      var msgs = [];
      if (hasMissingPlan) msgs.push('Abonnement nog niet beschikbaar voor ' + missingNames.join(', ') + '.');
      if (hasOOS) msgs.push('Tijdelijk uitverkocht: ' + oosNames.join(', ') + '.');
      if (msgs.length) {
        warnEl.textContent = msgs.join(' ');
        warnEl.removeAttribute('hidden');
      } else {
        warnEl.setAttribute('hidden', '');
      }
    }

    if (submitBtn) {
      var canSubmit = complete && !hasMissingPlan && !hasOOS;
      submitBtn.disabled = !canSubmit;
      submitBtn.textContent = complete
        ? (hasMissingPlan ? 'Abonnement onbeschikbaar' : (hasOOS ? 'Ritueel uitverkocht' : 'Naar afrekenen'))
        : ('Nog ' + remaining + ' cups');
    }
  }

  // Event wiring
  closes.forEach(function (b) { b.addEventListener('click', close); });
  if (backBtn) backBtn.addEventListener('click', function () {
    // From abo-details we step back into the abo builder. Anywhere else, close.
    if (state.step === 'abo-details') { showStep('abo'); return; }
    close();
  });
  // Path buttons are gone, but keep the listener for any stragglers (no-op).
  pathBtns.forEach(function (b) { b.addEventListener('click', function () { selectPath(b.getAttribute('data-tdr-mc-select')); }); });
  picks.forEach(function (pick) {
    var slug = pick.getAttribute('data-tdr-mc-pick');
    var inc = pick.querySelector('[data-tdr-mc-inc]');
    var dec = pick.querySelector('[data-tdr-mc-dec]');
    if (inc) inc.addEventListener('click', function () { update(slug, STEP); });
    if (dec) dec.addEventListener('click', function () { update(slug, -STEP); });
  });
  if (cadenceSelect) {
    cadenceSelect.value = state.cadence;
    applyAvailableCadences();
    if (cadenceSelect.value !== state.cadence) cadenceSelect.value = state.cadence;
    cadenceSelect.addEventListener('change', function () {
      var v = String(cadenceSelect.value);
      if (CADENCE[v]) {
        state.cadence = v;
        saveDraft();
        renderAbo();
      }
    });
  } else {
    // Cadence card might be replaced by static label. Still apply.
    applyAvailableCadences();
  }

  // ESC + backdrop close
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && state.open) close();
  });

  async function showError(el, fallback, res) {
    var msg = fallback;
    try {
      var body = await res.json();
      if (body && (body.description || body.message)) msg = body.description || body.message;
    } catch (e) { /* ignore */ }
    if (warnEl) {
      warnEl.textContent = msg;
      warnEl.removeAttribute('hidden');
    }
    return msg;
  }

  function showSuccessMoment(message, redirectTo) {
    var panel = root.querySelector('.tdr-mc__panel');
    if (!panel) { window.location.href = redirectTo; return; }
    var overlay = document.createElement('div');
    overlay.className = 'tdr-mc__success';
    overlay.setAttribute('role', 'status');
    overlay.setAttribute('aria-live', 'polite');
    overlay.innerHTML = ''
      + '<div class="tdr-mc__success-inner">'
      + '  <svg viewBox="0 0 48 48" width="48" height="48" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true" class="tdr-mc__success-check"><circle cx="24" cy="24" r="22"/><path d="M14 24l7 7 13-14"/></svg>'
      + '  <p class="tdr-mc__success-msg">' + message + '</p>'
      + '  <p class="tdr-mc__success-sub">We brengen je naar afrekenen...</p>'
      + '</div>';
    panel.appendChild(overlay);
    // give the eye a beat, then redirect
    setTimeout(function () { window.location.href = redirectTo; }, 1100);
  }

  // Defensive: clear any non-subscription items in the cart before redirect.
  async function clearCart() {
    try {
      await fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } });
    } catch (e) { /* ignore - additive add still works */ }
  }

  // Always go straight to checkout. Pricing is flat across cadences.
  function checkoutUrl() { return '/checkout'; }

  // Payment method picker: fetch active methods from bridge once, render radios.
  var methodsLoaded = false;
  var methodSelected = 'ideal';
  function renderMethods(methods) {
    if (!methodsGrid) return;
    methodsGrid.innerHTML = '';
    if (!methods.length) {
      var msg = document.createElement('p');
      msg.className = 'tdr-mc__methods-loading';
      msg.textContent = 'Geen betaalmethodes beschikbaar.';
      methodsGrid.appendChild(msg);
      return;
    }
    methods.forEach(function (m, idx) {
      var lbl = document.createElement('label');
      lbl.className = 'tdr-mc__method-option' + (idx === 0 ? ' tdr-mc__method-option--active' : '');
      lbl.innerHTML = ''
        + '<input type="radio" name="paymentMethod" value="' + m.id + '"' + (idx === 0 ? ' checked' : '') + '>'
        + (m.image ? '<img src="' + m.image + '" alt="" loading="lazy">' : '')
        + '<span class="tdr-mc__method-option-text">' + m.description + '</span>';
      var input = lbl.querySelector('input');
      input.addEventListener('change', function () {
        methodSelected = input.value;
        Array.from(methodsGrid.querySelectorAll('.tdr-mc__method-option')).forEach(function (el) {
          el.classList.remove('tdr-mc__method-option--active');
        });
        lbl.classList.add('tdr-mc__method-option--active');
      });
      methodsGrid.appendChild(lbl);
    });
    methodSelected = methods[0].id;
  }
  async function loadMethodsOnce() {
    if (methodsLoaded || !methodsGrid) return;
    methodsLoaded = true;
    try {
      var res = await fetch(BRIDGE_URL + '/api/methods', { method: 'GET', headers: { 'Accept': 'application/json' } });
      var json = await res.json();
      if (json && json.ok && Array.isArray(json.methods)) {
        renderMethods(json.methods);
      } else {
        renderMethods([{ id: 'ideal', description: 'iDEAL', image: null }]);
      }
    } catch (e) {
      renderMethods([{ id: 'ideal', description: 'iDEAL', image: null }]);
    }
  }

  // Build the product summary block for the abo-details step.
  function renderSummary() {
    if (!summaryMixEl) return;
    var pickMeta = {
      focus: { name: 'Focus', mushroom: 'Lion’s Mane' },
      drive: { name: 'Drive', mushroom: 'Cordyceps' },
      unwind: { name: 'Unwind', mushroom: 'Reishi' }
    };
    var html = '';
    ['focus', 'drive', 'unwind'].forEach(function (slug) {
      var cups = state.picks[slug] || 0;
      if (cups <= 0) return;
      var meta = pickMeta[slug] || { name: slug, mushroom: '' };
      html += '<li>' +
        '<span><span class="name">' + meta.name + '</span> <span class="meta">' + meta.mushroom + '</span></span>' +
        '<span class="qty">' + cups + ' cups</span>' +
        '</li>';
    });
    summaryMixEl.innerHTML = html || '<li><span class="meta">Nog geen cups gekozen</span></li>';
    if (summaryCadenceEl) {
      var cad = CADENCE[state.cadence] || CADENCE[DEFAULT_CADENCE];
      summaryCadenceEl.textContent = 'Elke ' + cad.label;
    }
    if (summaryTotalEl) summaryTotalEl.textContent = totalCups() + ' cups per levering';
  }

  // Submit ABO step → go to details step (collect email + shipping → bridge)
  if (submitBtn) {
    submitBtn.addEventListener('click', function () {
      if (submitBtn.disabled || state.submitting) return;
      if (totalCups() !== TOTAL) return;
      // Sync amount on details step
      if (detailsAmountEl) detailsAmountEl.textContent = footerAmountEl ? footerAmountEl.textContent : 'EUR 59,94';
      renderSummary();
      showStep('abo-details');
      loadMethodsOnce();
    });
  }
  if (summaryEditBtn) {
    summaryEditBtn.addEventListener('click', function () { showStep('abo'); });
  }

  // Account type toggle: show/hide business fields based on radio selection.
  // Also hides the welkomspakket card on the abo-details step because B2B
  // subscriptions do not qualify for the welkomstkorting.
  var accountTypeRadios = root.querySelectorAll('input[name="accountType"]');
  var businessFieldsEl = root.querySelector('[data-tdr-mc-business-fields]');
  var welkomEl = root.querySelector('[data-tdr-mc-welkom]');
  function syncAccountType() {
    if (!businessFieldsEl) return;
    var checked = root.querySelector('input[name="accountType"]:checked');
    var isBusiness = checked && checked.value === 'business';
    if (isBusiness) businessFieldsEl.removeAttribute('hidden');
    else businessFieldsEl.setAttribute('hidden', '');
    var companyInput = businessFieldsEl.querySelector('input[name="companyName"]');
    if (companyInput) companyInput.required = isBusiness;
    if (welkomEl) {
      if (isBusiness) welkomEl.setAttribute('hidden', '');
      else welkomEl.removeAttribute('hidden');
    }
  }
  accountTypeRadios.forEach(function (r) { r.addEventListener('change', syncAccountType); });
  syncAccountType();

  // Separate billing address toggle.
  var separateBillingEl = root.querySelector('[data-tdr-mc-separate-billing]');
  var billingFieldsEl = root.querySelector('[data-tdr-mc-billing-fields]');
  function syncBillingToggle() {
    if (!billingFieldsEl || !separateBillingEl) return;
    if (separateBillingEl.checked) billingFieldsEl.removeAttribute('hidden');
    else billingFieldsEl.setAttribute('hidden', '');
    var requiredNames = ['billingFirstName', 'billingLastName', 'billingAddress1', 'billingZip', 'billingCity'];
    requiredNames.forEach(function (n) {
      var inp = billingFieldsEl.querySelector('input[name="' + n + '"]');
      if (inp) inp.required = separateBillingEl.checked;
    });
  }
  if (separateBillingEl) separateBillingEl.addEventListener('change', syncBillingToggle);
  syncBillingToggle();

  // Submit ABO DETAILS → POST to bridge → redirect to Mollie checkout
  function syncErrorMessage(text) {
    if (!detailsWarnEl) return;
    if (!text) { detailsWarnEl.setAttribute('hidden', ''); detailsWarnEl.textContent = ''; return; }
    detailsWarnEl.removeAttribute('hidden');
    detailsWarnEl.textContent = text;
  }
  if (detailsForm) {
    detailsForm.addEventListener('submit', async function (e) {
      e.preventDefault();
      if (state.submitting) return;
      if (totalCups() !== TOTAL) {
        syncErrorMessage('Je mix moet precies 60 cups bevatten.');
        showStep('abo');
        return;
      }
      // Build mix
      var mix = [];
      ['focus', 'drive', 'unwind'].forEach(function (slug) {
        var cups = state.picks[slug] || 0;
        if (cups > 0) mix.push({ ritual: slug, cups: cups });
      });
      // Read form
      var fd = new FormData(detailsForm);
      var accountType = (fd.get('accountType') || 'personal').toString();
      var separateBilling = !!fd.get('separateBilling');
      var companyName = (fd.get('companyName') || '').toString().trim();
      if (accountType === 'business' && !companyName) {
        syncErrorMessage('Vul je bedrijfsnaam in om zakelijk te bestellen.');
        return;
      }
      var payload = {
        email: (fd.get('email') || '').toString().trim(),
        firstName: (fd.get('firstName') || '').toString().trim() || undefined,
        lastName: (fd.get('lastName') || '').toString().trim() || undefined,
        phone: (fd.get('phone') || '').toString().trim() || undefined,
        cadenceWeeks: Number(state.cadence),
        currency: 'EUR',
        method: methodSelected || undefined,
        mix: mix,
        accountType: accountType,
        companyName: accountType === 'business' ? companyName : undefined,
        kvkNumber: accountType === 'business' ? ((fd.get('kvkNumber') || '').toString().trim() || undefined) : undefined,
        vatNumber: accountType === 'business' ? ((fd.get('vatNumber') || '').toString().trim() || undefined) : undefined,
        shippingAddress: {
          firstName: (fd.get('firstName') || '').toString().trim() || undefined,
          lastName: (fd.get('lastName') || '').toString().trim() || undefined,
          address1: (fd.get('address1') || '').toString().trim() || undefined,
          city: (fd.get('city') || '').toString().trim() || undefined,
          zip: (fd.get('zip') || '').toString().trim() || undefined,
          countryCode: 'NL',
          phone: (fd.get('phone') || '').toString().trim() || undefined
        },
        billingAddress: separateBilling ? {
          firstName: (fd.get('billingFirstName') || '').toString().trim() || undefined,
          lastName: (fd.get('billingLastName') || '').toString().trim() || undefined,
          address1: (fd.get('billingAddress1') || '').toString().trim() || undefined,
          city: (fd.get('billingCity') || '').toString().trim() || undefined,
          zip: (fd.get('billingZip') || '').toString().trim() || undefined,
          countryCode: 'NL'
        } : undefined
      };
      if (!payload.email) { syncErrorMessage('Vul een e-mailadres in.'); return; }
      if (!detailsForm.checkValidity()) { detailsForm.reportValidity(); return; }

      state.submitting = true;
      var orig = detailsSubmitBtn.textContent;
      detailsSubmitBtn.disabled = true;
      detailsSubmitBtn.textContent = 'Moment...';
      syncErrorMessage('');
      try {
        var res = await fetch(BRIDGE_URL + '/api/subscribe', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        });
        var json = await res.json().catch(function () { return null; });
        if (!res.ok || !json || !json.ok) {
          var errMsg = (json && json.error) ? ('Bridge fout: ' + json.error) : 'Er ging iets mis. Probeer opnieuw.';
          syncErrorMessage(errMsg);
          throw new Error('bridge-error');
        }
        try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
        // Off to Mollie hosted iDEAL page
        window.location.href = json.checkoutUrl;
      } catch (err) {
        state.submitting = false;
        detailsSubmitBtn.disabled = false;
        detailsSubmitBtn.textContent = orig || 'Naar betalen →';
      }
    });
  }

  // Trigger registration
  function bindTriggers() {
    document.querySelectorAll('[data-tdr-open-mix]').forEach(function (el) {
      if (el.dataset.tdrMcBound) return;
      el.dataset.tdrMcBound = '1';
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var path = el.getAttribute('data-tdr-open-mix');
        if (path === 'neutral' || !path) path = null;
        open(path);
      });
    });
  }

  // Deep link / auto-open
  function checkAutoOpen() {
    var url = new URL(window.location.href);
    var mix = url.searchParams.get('mix');
    var composer = url.searchParams.get('composer');
    // Subscription is the only path now. Any legacy ?mix=testpakket opens
    // the abo builder so old links from prior copy don't 404 the experience.
    if (mix === 'abo' || mix === 'testpakket') {
      open('abo');
    } else if (composer === '1') {
      open();
    }
  }

  bindTriggers();
  // Re-bind after dynamic header / drawer renders
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(bindTriggers);
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAutoOpen);
  } else {
    checkAutoOpen();
  }

  // Initial render in case stored state has picks
  if (totalCups() > 0) renderAbo();
})();
